<template>
  <ColumnWithHelp
    :resizable="false"
    column-key="status"
    :filters="statusFilters"
    :min-width="150"
    :label="label"
    :title="label"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_STATUS_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { status } }">
      {{ getBidState(status) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import bidState from '@/mixins/bidState';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'BidStatusColumn',
  components: {
    ColumnWithHelp,
  },
  mixins: [bidState],
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusFilters() {
      return [
        {
          value: 'P',
          text: this.$t('ADVERTISEMENT.BID.PENDING'),
        },
        {
          value: 'W',
          text: this.$t('ADVERTISEMENT.BID.ACTIVE'),
        },
        {
          value: 'L',
          text: this.$t('ADVERTISEMENT.BID.LOSER'),
        },
        {
          value: 'R',
          text: this.$t('ADVERTISEMENT.BID.REJECTED'),
        },
        {
          value: 'A',
          text: this.$t('ADVERTISEMENT.BID.ALERTED'),
        },
        {
          value: 'C',
          text: this.$t('ADVERTISEMENT.BID.CAMPAIGN_STOPPED'),
        },
      ];
    },
  },
};
</script>
